angular.module('qkr').config(settingHttpHeaders);

angular.module('qkr').constant('newAppConfig', require('./appConfig.json'));

settingHttpHeaders.$inject = ['$httpProvider', '$locationProvider'];

function settingHttpHeaders($httpProvider, $locationProvider) {
    // Initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }

    $locationProvider.hashPrefix('');
    delete $httpProvider.defaults.headers.common['X-Requested-With'];

    // Disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';
}

angular.module('qkr').run(settingModalSessionTimeoutAlert);
function settingModalSessionTimeoutAlert($uibModal, sessionExpiryEventService) {
    /**
     *  Why is the modal being bound here ?
     *
     *      Well, whenever MSS tries to make a $http request we want to set a timer that will inform the user in the
     *      form of a $modal that they have 25 mins (out of their 30 mins) left before their session with the
     *      website is invalidated.
     *      We have a listener further down, looking at $httpProvider, that does an action when a request is made, but
     *      we can't put a modal there because during the angular's configuration certain services such as $modal
     *      aren't available.
     *      Therefore, we add a callback function here in 'run' once everything has been instantiated that we can
     *      invoke in future cases where requests are made.
     *      This is a subscription service to provide a hook for our modal that can be produced anywhere in the
     *      application.
     */

    if(window && window.location && window.location.pathname && window.location.pathname.indexOf('index.html') > -1){
        return; //don't show session time out popup on login screen...
    }
    const subscribeFunc = $uibModal.open.bind(null, {
        template: require('./sessionExpiry/templates/sessionExpiry.html'),
        controller: 'SessionExpiryController',
        controllerAs: 'vm',
        windowClass: 'modal-image  modal-borderless modal-small responsive',
        size: 'sm',
        backdrop: 'static'
    });
    sessionExpiryEventService.addSubscriber(subscribeFunc);
}

angular.module('qkr')
    .run(function settingMssLanguage(gettextCatalog, $rootScope, messageService, appConfig, appConfigService, utils,
                                     APP_CONSTANT, $http) {
        $rootScope.APP_CONSTANT = APP_CONSTANT;

        $http.post(appConfigService.createUrl('/auth/initIndex'), {})
            .then(response => response.data)
            .catch(response => {
                throw response.data;
            })
            .then(response => {
                const localeString = response.locale;
                if (localeString) {
                    appConfig.poFileNames = response.poFileNames;
                    appConfig.locale = localeString;
                    gettextCatalog.currentLanguage = utils.getLocale(localeString, response.poFileNames);

                    // Debug mode to test
                    if (gettextCatalog.currentLanguage === 'es' && appConfig.env !== 'production') {
                        gettextCatalog.debug = true;
                    }

                    messageService.log('Current Language=' + gettextCatalog.currentLanguage);
                }
            })
            .catch(data => data.error);
    });


angular.module('qkr').config(($routeSegmentProvider, $routeProvider, $httpProvider, $provide, appUrl) => {

    $routeSegmentProvider.options.autoLoadTemplates = true;

    $routeSegmentProvider.
        when('/login', 'login').
        when('/outlet/:outletId', 'outlet').
        when('/newmenus', 'newmenus').
        when('/merchant/sharedMenus', 'sharedMenus').
        when('/merchant/sharedMenus/:menuId', 'sharedMenus.view_menu').
        when('/business', 'business_info').
        when('/beneficiary', 'beneficiary', { pageTitle: 'Student Settings' }).
        when('/storefront_appearance', 'storefront_appearance', { pageTitle: 'Storefront Appearance' }).
        when('/storefront_contact', 'storefront_contact', { pageTitle: 'Storefront Details' }).
        when('/storefronts', 'storefronts').
        when('/optionsets', 'optionsets', { pageTitle: 'Option Sets' }).
        when('/accountancy_settings', 'accountancy_settings', { pageTitle: 'Accountancy Settings' }).
        when('/profile_data_upload', 'profile_data_upload').
        when('/cases21_familynumber', 'cases21_familynumber', { pageTitle: 'Debtor IDs' }).
        when('/cases21_inventory', 'cases21_inventory', { pageTitle: 'Categorisation' }).
        when('/password', 'password', { pageTitle: 'Account Settings' }).
        when('/home', 'home', { pageTitle: 'Welcome' }).
        when('/help/:helpId', 'help').
        when('/rna/:pageName', 'rna', { pageTitle: 'Analytics' }).
        when('/legacy_configuration', 'legacy_configuration', { pageTitle: 'Other configuration' }).
        when('/feedbacks', 'feedbacks').
        when('/thankyou', 'thankyou').
        when('/marketing/:outletId', 'marketing', { pageTitle: 'Communications' }).
        when('/rewardProduct', 'rewardProduct').
        when('/analytics_merchant', 'analytics_merchant').
        when('/forms', 'forms', { pageTitle: 'Forms' }).
        when('/forms/createTemplate', 'createTemplate', { pageTitle: 'Create Template' }).
        when('/forms/editTemplate/:templateId', 'editTemplate', { pageTitle: 'Edit Template' }).
        when('/forms/copyTemplate/:templateId', 'copyTemplate', { pageTitle: 'Create Template' }).
        when('/forms/formView/:formId', 'formView').
        when('/forum', 'forum', { pageTitle: 'Forum' }).
        when('/merchant/outlets', 'merchantAdminOutlets', { pageTitle: 'Outlets' }).
        when('/merchant/formOutlet', 'outletPage').
        when('/merchant/settings', 'merchantAdminSettings', { pageTitle: 'Merchant Settings' }).
        when('/merchant/password', 'merchantPasswordReset').
        when('/merchant/usermanagement', 'userManagement', { pageTitle: 'User Management' }).

        when('/merchant/optionsets', 'merchantAdminOptionSets').
        when('/merchant/loyalty', 'loyalty').
        when('/merchant/loyaltyCardList', 'loyaltyCardList').
        when('/merchant/loyaltyCardCreate', 'loyaltyCardCreate').
        when('/merchant/loyaltyCardCreate/:loyaltyCardId', 'loyaltyCardCreate').
        when('/mastercard/merchants', 'merchants', { pageTitle: 'Merchants' }).
        when('/mastercard/partnerTermsAndConditions', 'partnerTermsAndConditions').
        when('/mastercard/merchants/:partnerId', 'merchants', { pageTitle: 'Partner' }).
        when('/mastercard/merchant/registration', 'registration', {pageTitle: 'Add a new Merchant'}).
        when('/mastercard/taxSales', 'taxSales').
        when('/mastercard/usermanagement', 'userManagement', { pageTitle: 'User Management' }).
        when('/mastercard/partners', 'partners', { pageTitle: 'Partners' }).
        when('/quest', 'quest').
        when('/merchantTandC', 'merchantTandC').
        when('/merchantPrivacy', 'merchantPrivacy').
        when('/mastercard/keys', 'keys', { pageTitle: 'Direct API Keys' }).
        when('/mastercard/pushNotification', 'pushNotification', { pageTitle: 'Push Notifications' }).
        when('/machines:AtMerchant?', 'machines').
        when('/mastercard/key/:keyId', 'key');

    $routeSegmentProvider.
        segment('login', {
            template: require('./login/login.html'),
            controller: 'IndexController as vm'
        })
        .segment('outlet', {
            template: require('./templates/outlet/storefront.html'),
            dependencies: ['outletId']
        })
        .segment('optionsets', {
            template: require('./templates/inventory/optionSets.html')
        })
        .segment('newmenus', {
            template: require('./templates/menu/menus.html'),
            controller: 'menusController',
            controllerAs: 'vm',
            untilResolved: {
                template: require('./shared/loading-screen.html')
            },
            resolveFailed: {
                template: require('./shared/loading-error.html')
            },
            resolve : {
                outletDepartmentData(outletService) {
                    'ngInject';
                    return outletService.loadCurrentOutletDepartments()
                }
            }
        }).
        segment('sharedMenus', {
            template: require('./templates/menu/sharedMenus.html'),
            controller: 'sharedMenusController',
            resolve: {
                sharedMenus(menuService) {
                    'ngInject';
                    return menuService.loadSharedMenus()
                        .then(menus => menus.filter(menu => menu.shared));
                }
            },
            untilResolved: {
                template: require('./shared/loading-screen.html')
            },
            resolveFailed: {
                template: require('./shared/loading-error.html')
            }
        })
        .segment('business_info', {
            template: require('./templates/business/info.html')
        })
        .segment('beneficiary', {
             resolve: {
                 outletInfo(outletService) {
                     'ngInject';
                     return outletService.loadOutlet();
                 }
             },
             controller: 'beneficiaryController',
             template: require('./templates/beneficiary/beneficiary.html'),
             untilResolved: {
                template: require('./shared/loading-screen.html')
             }})
        .segment('storefront_appearance', {
            controller: 'storefrontController',
            template: require('./templates/business/storefront_appearance.html'),
            resolve: getStoreFrontResolve()
        }).
        segment('storefront_contact', {
            controller: 'storefrontController',
            template: require('./templates/business/storefront_contact.html'),
            resolve: getStoreFrontResolve()
        })
        .segment('storefronts', {
            template: require('./templates/outlet/storefronts.html')
        })
        .segment('home', {
            template: require('./templates/dashboard/dashboard.html')
        })
        .segment('help', {
            template: require('./templates/dashboard/help.html'),
            dependencies: ['helpId']
        })
        .segment('accountancy_settings', {
            template: require('./templates/accountancy/accountancySettings.html')
        })
        .segment('profile_data_upload', {
            template: require('./templates/accountancy/profileDataUpload.html')
        })
        .segment('cases21_familynumber', {
            controller: 'cases21Controller',
            template: require('./templates/accountancy/cases21/familynumber.html'),
            resolve: {
                familyInfo(cases21Service) {
                    'ngInject';
                    return cases21Service.loadFamilyInfo();
                },
                beneficiaryCustomFields(beneficiariesService) {
                    'ngInject';
                    return beneficiariesService.loadBeneficiaryCustomFields();
                }
            }
        })
        .segment('cases21_inventory', {
            template: require('./templates/accountancy/cases21/inventory.html')
        })
        .segment('rna', {
            template: require('./templates/rna/rna.html')
        })
        .segment('legacy_configuration', {
            template: require('./templates/legacyconfig/configuration.html')
        })
        .segment('quest', {
            template: require('./templates/quest/quest.html')
        })
        .segment('marketing', {
            controller: 'marketingController',
            template: require('./templates/marketing/marketing.html'),
            resolve: {
                outlet(outletService, $routeParams) {
                    'ngInject';
                    return outletService.loadOutlet($routeParams.outletId);
                },
                remoteLinks($http, appConfig) {
                    'ngInject';
                    return $http({
                        method: 'GET',
                        url: appConfig.apiUrl + 'marketing/getMarketingMaterialLinks'
                    }).then(response => response.data);
                }
            }
        })
        .segment('feedbacks', {
            template: require('./templates/feedback/list.html')
        })
        .segment('thankyou', {
            template: require('./templates/registration/thankyou.html')
        })
        .segment('password', {
            template: require('./templates/password.html'),
            controller: 'PasswordController'
        })
        .segment('merchantTandC', {
            template: require('./templates/merchantTandC.html')
        })
        .segment('merchantPrivacy', {
            template: require('./templates/merchantPrivacy.html')
        })
        .segment('rewardProduct', {
            template: require('./templates/loyalty/rewardProduct.html')
        })
        .segment('loyalty', {
            template: require('./templates/loyalty/loyalty.html')
        })
        .segment('loyaltyCardList', {
            template: require('./loyalty/templates/loyaltyCardList.html')
        })
        .segment('loyaltyCardCreate', {
            controller: 'LoyaltyCardCreateController',
            template: require('./loyalty/templates/loyaltyCardCreate.html'),
            dependencies: ['loyaltyCardId'],
            resolve: {
                loyaltyCard($routeParams, loyaltyCardService) {
                    'ngInject';
                    if ($routeParams.loyaltyCardId !== null) {
                        return loyaltyCardService.getLoyaltyCard($routeParams.loyaltyCardId);
                    } else {
                        return null;
                    }
                }
            }
        })
        .segment('analytics_merchant', {
            template: require('./templates/analytics/analytics_merchant.html')
        })
        .segment('forms', {
            template: require('./templates/forms/forms.html')
        })
        .segment('formView', {
            template: require('./templates/forms/formView.html'),
            dependencies: ['formId'] 
        })
        .segment('createTemplate', {
            controller: 'templateController',
            controllerAs: 'templateCtrl',
            template: require('./templates/forms/template.html'),
            resolve: {
                isCopy() {
                    return false;
                }
            }
        })
        .segment('editTemplate', {
        	controller: 'templateController',
        	controllerAs: 'templateCtrl',
        	template: require('./templates/forms/template.html'),
        	dependencies: ['templateId'], 
        	resolve: {
        		isCopy() {
        			return false;
        		}
        	}
        })
        .segment('copyTemplate', {
        	controller: 'templateController',
        	controllerAs: 'templateCtrl',
        	template: require('./templates/forms/template.html'),
        	dependencies: ['templateId'], 
        	resolve: {
        		isCopy() {
        			return true;
        		}
        	}
        })
        .segment('merchantAdminOutlets', {
            controller: 'OutletsController',
            controllerAs: 'vm',
            template: require('./controllers/merchant/outlets.html'),
            resolve: {
                merchant(merchantService) {
                    'ngInject';
                    return merchantService.loadMerchantResponse();
                },
                contactDetailsData(contactDetailsService) {
                    'ngInject';
                    return contactDetailsService.listCityStateForMerchant();
                },
                supportedCountries(systemSettingsService) {
                    'ngInject';
                    return systemSettingsService.loadSupportedCountries();
                }
            }
        })
        .segment('forum', {
            template: require('./templates/forum/forum.html'),
            controller: 'ForumController as vm',
            resolve: {
                merchantInfoData(merchantService, appConfig) {
                    'ngInject';
                    if (!appConfig.isMCAdmin && !appConfig.isPartner) {
                        return merchantService.loadMerchantInfo();
                    } else {
                        return null;
                    }
                }
            }
        })
        .segment('outletPage', {
            template: require('./controllers/merchant/outlet.registration.html'),
            controller: 'OutletRegistration',
            controllerAs: 'vm',
            resolve: {
                merchantInfoData(merchantService) {
                    'ngInject';
                    return merchantService.loadMerchantInfo();
                }
            }
        })
        .segment('merchantAdminOptionSets', {
            template: require('./templates/inventory/optionSets.html')
        })
        .segment('merchants', {
            controller: 'MerchantsController',
            controllerAs: 'merchantsCtrl',
            template: require('./controllers/mastercard/merchants.html'),
            dependencies: ['partnerId'],
            resolve: getMerchantPartnerList(),
            untilResolved: {
                template: require('./shared/loading-screen.html')
            },
            resolveFailed: {
                template: require('./shared/loading-error.html')
            }
        })
        .segment('registration', {
            template: require('./controllers/mastercard/registration.html'),
            controller: 'RegistrationController',
            controllerAs: 'vm',
            resolve: {
                user(userManagementService, appConfig) {
                    'ngInject';
                    return userManagementService.getWebUserBySessionId(appConfig.username);
                },
                partners(partnerService) {
                    'ngInject';
                    return partnerService.listPartners();
                },
                businessCategories(systemSettingsService) {
                    'ngInject';
                    return systemSettingsService.loadBusinessCategories();
                }
            }
        })
        .segment('taxSales', {
            template: require('./controllers/mastercard/taxSales.html')
        })
        .segment('userManagement', {
            template: require('./templates/usermanagement/listUser.html')
        })

        .segment('partners', {
            template: require('./controllers/mastercard/partners.html'),
            controller: 'PartnersController',
            controllerAs: 'vm',
            resolve: {
                partners(partnerService) {
                    'ngInject';
                    return partnerService.listPartners();
                },
                categories(systemSettingsService) {
                    'ngInject';
                    return systemSettingsService.loadBusinessCategories();
                }
            }
        })
        .segment('merchantAdminSettings', {
            controller: 'merchantSettingsController',
            template: require('./controllers/merchant/merchant.settings.html'),
            untilResolved: {
                template: require('./shared/loading-screen.html')
            },
            resolveFailed: {
                template: require('./shared/loading-error.html')
            },
            resolve: {
                merchantInfoData(merchantService) {
                    'ngInject';
                    return merchantService.loadMerchantInfo();
                }
            }
        })
        .segment('keys', {
            template: require('./controllers/mastercard/keys.html')
        })
        .segment('pushNotification', {
            template: require('./controllers/mastercard/pushNotification.html')
        })
        .segment('machines', {
            template: require('./controllers/merchant/machines.html'),
            controller: 'MachinesController',
            controllerAs: 'vm',
            resolve: {
                outletSummaryList (outletService) {
                    'ngInject';
                    return outletService.listOutletsSummary();
                },
                machines(machinesServices){
                    'ngInject';
                    return machinesServices.loadList().then(response => response.data || []);
                },
                getDiscountLabelFn(machinesServices){
                    'ngInject';
                    return machinesServices.getDiscountLabel;
                },
                deleteMachineFn(machinesServices){
                    'ngInject';
                    return machinesServices.deleteMachine;
                }
            },
            untilResolved: {
                template: require('./shared/loading-screen.html')
            },
            resolveFailed: {
                template: require('./shared/loading-error.html')
            }
        })
        .segment('key', {
            template: require('./controllers/mastercard/key.html')
        });

    $routeProvider.otherwise({

        redirectTo: appUrl.pageLanding
    });

    $httpProvider.defaults.withCredentials = true;

    $provide.factory('mssHttpInterceptor', function($q, sessionExpiryEventService) {
        'ngInject'; // need this for injection
        return {

            response(response) {
                sessionExpiryEventService.refreshSessionTimeout();
                return response;
            },
            responseError(response) {
                return $q.reject(response);
            }
        };
    });

    $httpProvider.interceptors.push('mssHttpInterceptor');

    function getStoreFrontResolve() {
        return {
            merchantResponseData(merchantService) {
                'ngInject';
                return merchantService.loadMerchantResponse();
            },
            outletData(outletService) {
                'ngInject';
                return outletService.loadOutlet();
            }
        };
    }

    function getMerchantPartnerList() {
        return {
          partnerList($routeParams, partnerService) {
              'ngInject';
              if ($routeParams.partnerId) {
                return partnerService.getPartner($routeParams.partnerId)
                    .then(partner => [partner]);
            } else {
                return partnerService.listPartners();
            }
          }
        };
    }
});


angular.module('qkr').run(['$rootScope', '$window', function($rootScope, $window) {
    const _defaultTitle = $window.document.title || 'Qkr! Store Manager';

    $rootScope.$on('$routeChangeSuccess', function (event, route) {
        if (route && angular.isDefined(route.$$route)) {
            let pageTitle = route.$$route.pageTitle || null;

            if(pageTitle){
                pageTitle =  pageTitle + ' | ' + _defaultTitle;
            }else{
                pageTitle = _defaultTitle;
            }
            $window.document.title = pageTitle;

            //Set the default focus back to the "skip to main content"
            // header as required for accessibility
            setDefaultFocus();
        }
    });

    const setDefaultFocus = function () {
        let defaultFocus = document.querySelector("header");

        if (defaultFocus) {

            if (document.activeElement) {
                document.activeElement.blur();
            }
            defaultFocus.focus();
        }
    }

}]);



// WEBPACK FOOTER //
// ./src/main.js